import React, { useEffect, useState } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/contact-us.png';
import { Wrapper } from './Landing';
import { useForm } from 'react-hook-form';
import styled from 'styled-components/macro';
import Spinner from '../components/Spinner';

const Wrap = styled(Wrapper)`
  position: relative;
  width: 100%;

  & .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  & form {
    position: relative;
    width: 100%;
    max-width: 400px;

    & > div {
      position: relative;
      width: 100%;
    }
  }

  & label {
    display: block;
    width: auto;
    text-align: left;
    margin-top: 12px;
    margin-bottom: 6px;
    color: #7b95a6;
    font-family: 'Roboto Condensed';
  }

  & button {
    background-color: #7b95a6;
    color: #f2f2f2;
    font-family: 'Roboto Condensed';
    font-size: 1.2rem;
    line-height: 1.6em;
    padding: 6px 24px;
    border-radius: 48px;
    outline: none;

    &:hover {
      background-color: #94b3c8;
    }

    &:disabled {
      background-color: #94b3c8;
      color: #f2f2f2;
      cursor: not-allowed;
    }
  }

  & .btn-row {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 32px 0;
  }
`;

const Input = styled.input`
  display: block;
  width: 100%;
  height: 24px;
  padding: 16px 12px;
  font-family: Roboto;
  font-size: 1rem;
  border: 1px solid #7b95a65c;
  color: #3c4f5b;
  outline: none;

  &::placeholder {
    color: #7b95a68c;
    font-style: italic;
  }
`;

const Textarea = styled.textarea`
  display: block;
  width: 100%;
  height: 200px;
  border: 1px solid #7b95a65c;
  font-family: Roboto;
  font-size: 1rem;
  border: 1px solid #7b95a65c;
  color: #3c4f5b;
  padding: 16px 12px;
  outline: none;
`;

const Error = styled.div`
  color: #a78a38;
  font-style: italic;
  margin-top: 6px;
`;

const ContactUs = () => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = 'Emprouen Advisors: Contact Us';
  }, []);

  const { register, handleSubmit, errors, reset, formState } = useForm({
    mode: 'onChange',
    submitFocusError: true
  });

  const onSubmit = async data => {
    setSending(true);
    console.log(data);

    try {
      await fetch(
        'https://qwd3mq862j.execute-api.us-east-1.amazonaws.com/prod/contact-us',
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          mode: 'cors',
          body: JSON.stringify(data)
        }
      );

      reset();
      setSent(true);
    } catch (e) {
      console.error(e);
      setError(true);
    }
    setSending(false);
  };

  return (
    <Wrap>
      <PageGraphic src={imgGrpahic} />
      <div>
        <h2>Contact</h2>

        <p>
          Please submit your contact information with a brief message and we'll
          get back to you shortly.
        </p>

        <div className="center">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label>* Full name:</label>
              <Input
                type="text"
                placeholder="required"
                name="fullname"
                ref={register({ required: true, maxLength: 80 })}
              />
              {errors.fullname && <Error>A name is required.</Error>}
            </div>

            <div>
              <label>* Email:</label>
              <Input
                type="text"
                placeholder="required"
                name="email"
                ref={register({ required: true, pattern: /^\S+@\S+$/i })}
              />
              {errors.email?.type === 'required' && (
                <Error>An email is required.</Error>
              )}
              {errors.email?.type === 'pattern' && (
                <Error>A valid email is required.</Error>
              )}
            </div>

            <div>
              <label>Company:</label>
              <Input type="text" name="company" ref={register} />
            </div>

            <div>
              <label>Phone Number:</label>
              <Input type="tel" name="phone" ref={register} />
            </div>

            <div>
              <label>* Message:</label>
              <Textarea name="message" ref={register({ required: true })} />
            </div>
            {errors.message && <Error>A message is required.</Error>}

            <div className="btn-row">
              {!sending && (
                <button type="submit" disabled={!formState.isValid}>
                  Submit
                </button>
              )}
              {sending && <Spinner />}
            </div>
          </form>
        </div>

        {sent && (
          <p>
            Your message has been successfully sent. Someone will be in touch
            with you shortly.
          </p>
        )}

        {error && (
          <p>
            <Error>
              Unfortunately, we were unable to send your request. Please try
              again shortly.
            </Error>
          </p>
        )}
      </div>
    </Wrap>
  );
};

export default ContactUs;
